// hooks/usePhoneField.js
"use client";

import { useState, useEffect } from 'react';
import { getCountryCallingCode, parsePhoneNumberFromString } from 'libphonenumber-js';

export function usePhoneField(initial = '', country = 'US') {
  const [rawValue, setRawValue] = useState(initial);
  const [confirmValue, setConfirmValue] = useState('');
  const [countryPrefix, setCountryPrefix] = useState('+1');

  // Update country prefix based on code
  useEffect(() => {
    try {
      setCountryPrefix('+' + getCountryCallingCode(country));
    } catch {
      setCountryPrefix('+');
    }
  }, [country]);

 const sanitize = (val = '') => String(val).replace(/[^\d]/g, '');


  const fullValue = `${countryPrefix}${sanitize(rawValue)}`;
  const fullConfirm = `${countryPrefix}${sanitize(confirmValue)}`;

  const mismatch = rawValue && confirmValue && sanitize(rawValue) !== sanitize(confirmValue);

  const parsed = parsePhoneNumberFromString(fullValue);
  const isValid = parsed?.isValid() || false;
  const formatted = parsed?.formatInternational() || fullValue;

  return {
    rawValue,
    setRawValue,
    confirmValue,
    setConfirmValue,
    countryPrefix,
    fullValue,
    fullConfirm,
    isValid,
    mismatch,
    formatted,
  };
}
